import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import React, { useCallback, useRef, useState } from 'react'
import TalentCalendarHeader from '../components/TalentCalendarHeader'
import TalentCalendarContent from './TalentCalendarContent'
import { Box } from '@mui/material'

const RecruiterCalendar = () => {
  const [calendarValue, setCalendarValue] = useState(new Date())

  const divRef = useRef([])

  const scrollToDiv = (index) => {
    if (divRef.current[index]) {
      divRef.current[index].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }

  const handleClick = useCallback((index) => {
    scrollToDiv(index)
  }, [])

  return (
    <DashboardContainer headerTitle="Recruiter Calendar" blockMobile>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TalentCalendarHeader
          calendarValue={calendarValue}
          setCalendarValue={setCalendarValue}
          handleClick={handleClick}
        />
        <TalentCalendarContent ref={divRef} calendarValue={calendarValue} />
      </Box>
    </DashboardContainer>
  )
}

export default RecruiterCalendar
